/**
 * Specifies the type of secondary size.
 * tag: 1178
 * @readonly
 * @enum {number} (int)
 */
export enum MDSecSizeType {
  Customer = 1,
  CustomerProfessional = 2,
  DoNotTradeThrough = 3,
}
